import React, { Component } from 'react';

import classNames from 'classnames';
import { Labeled } from 'components/ClubComponents';
import Tooltip from 'components/cosmos/tooltip';
import { setPosition } from 'components/cosmos/tooltip/helper';
import { ReactComponent as Interrogation } from 'components/svg/icons/interrogation.svg';
import { translate } from 'components/translate';
import isNil from 'lodash/isNil';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

@translate()
@inject((stores) => ({
  isMobile: stores.UiStore.isMobile
}))
@observer
class InputBlock extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    error: PropTypes.object,
    inline: PropTypes.bool,
    isMobile: PropTypes.bool,
    labelInfo: PropTypes.string,
    labelValue: PropTypes.string,
    name: PropTypes.string,
    min: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    mainValidation: PropTypes.object,
    maxLength: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
      PropTypes.number
    ]),
    maxRawLength: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    minLength: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    size: PropTypes.string,
    submitted: PropTypes.bool,
    t: PropTypes.func,
    translate: PropTypes.bool
  };

  static defaultProps = {
    type: 'text',
    mainValidation: { error: false }
  };

  get errorMessage() {
    const { submitted, error, mainValidation, t, name } = this.props;

    if (mainValidation.error) {
      return (
        <p className="error" data-test={`error-${name}`}>
          {t(`validations.${mainValidation.error}`, {
            data: mainValidation.data
          })}
        </p>
      );
    }

    if (submitted && error) {
      const firstError = this.firstError(error);

      return firstError ? firstError : null;
    }

    return null;
  }

  firstError(error) {
    const { min, maxLength, maxRawLength, minLength, t, name } = this.props;
    const {
      required: requiredError,
      min: minError,
      maxLength: maxLengthError,
      maxRawLength: maxRawLengthError,
      minLength: minLengthError
    } = error;

    const errors = [];

    const errorsLabels = [
      {
        value: requiredError,
        label: 'required'
      },
      {
        value: minError,
        label: 'min',
        data: { min }
      },
      {
        value: maxLengthError,
        label: 'maxLength',
        data: { maxLength }
      },
      {
        value: maxRawLengthError,
        label: 'maxRawLength',
        data: { maxRawLength }
      },
      {
        value: minLengthError,
        label: 'minLength',
        data: { minLength }
      }
    ];

    errorsLabels.forEach((error) => {
      error.value &&
        errors.push(
          <p className="error" data-test={`error-${error.label}-${name}`}>
            {t(`validations.${error.label}`, { data: error.data })}
          </p>
        );
    });

    return errors[0];
  }

  renderLabel() {
    const { isMobile, labelValue, labelInfo, t, translate = true } = this.props;

    return (
      !isNil(labelValue) && (
        <>
          {labelValue && translate ? t(labelValue) : labelValue}
          {labelInfo && (
            <Tooltip
              content={t(labelInfo)}
              position={setPosition(
                Tooltip.TOOLTIP_POSITION.TOP,
                Tooltip.TOOLTIP_POSITION.RIGHT,
                isMobile
              )}
              className="_ml-2 _pr-1"
            >
              <Interrogation />
            </Tooltip>
          )}
        </>
      )
    );
  }

  render() {
    const { className, children, inline, name, size } = this.props;
    const errorMessage = this.errorMessage;

    const classComponent = classNames('input__group', className, {
      'input__group__error': errorMessage,
      'input__group--inline': inline,
      'input--sm': size === 'sm'
    });

    return (
      <Labeled
        className={classComponent}
        htmlFor={name}
        label={this.renderLabel()}
      >
        {children}
        {errorMessage}
      </Labeled>
    );
  }
}

export default InputBlock;
